import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFollow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 36,
			height: 36,
			rx: 4,
			fill: "#282E9A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 16.334L20.9167 18.834L26.3333 16.334",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.25 23.0007H16.5833C16.296 23.0007 16.0205 22.8892 15.8173 22.6909C15.6141 22.4925 15.5 22.2235 15.5 21.943V14.8917C15.5 14.6112 15.6141 14.3421 15.8173 14.1438C16.0205 13.9454 16.296 13.834 16.5833 13.834H25.25C25.5373 13.834 25.8129 13.9454 26.016 14.1438C26.2192 14.3421 26.3333 14.6112 26.3333 14.8917V21.943C26.3333 22.2235 26.2192 22.4925 26.016 22.6909C25.8129 22.8892 25.5373 23.0007 25.25 23.0007V23.0007Z",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.83337 15.5H13",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 18.834H13",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1667 22.168H13.0001",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFollow;
